(() => {
  'use strict';

  if (window.__vrRitualFixesReady) return;
  window.__vrRitualFixesReady = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const managedVideos = new Set();

  const getConfig = () => document.querySelector('.vr-live-patch');

  const stripNativeControls = (video) => {
    if (!(video instanceof HTMLVideoElement)) return;
    video.controls = false;
    video.removeAttribute('controls');
    video.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');
    video.setAttribute('disablepictureinpicture', '');
    video.setAttribute('disableremoteplayback', '');
    video.disablePictureInPicture = true;
  };

  const safePlay = (video) => {
    if (!(video instanceof HTMLVideoElement) || reduceMotion.matches || document.hidden) return;
    stripNativeControls(video);
    video.muted = true;
    video.defaultMuted = true;
    const playPromise = video.play();
    if (playPromise?.catch) playPromise.catch(() => {});
  };

  const hardenAutoplay = (video) => {
    if (!(video instanceof HTMLVideoElement)) return;
    stripNativeControls(video);
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'auto';
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('aria-hidden', 'true');
    video.tabIndex = -1;

    if (!managedVideos.has(video)) {
      managedVideos.add(video);
      ['loadedmetadata', 'loadeddata', 'canplay'].forEach((eventName) => {
        video.addEventListener(eventName, () => safePlay(video));
      });
      video.addEventListener('playing', () => stripNativeControls(video));
    }

    safePlay(video);
  };

  const ensureWhyVideo = (root) => {
    const media = root.querySelector('.vrx-why__image');
    const config = getConfig();
    const sourceUrl = config?.dataset.vrxWhyVideo;
    const posterUrl = config?.dataset.vrxWhyPoster;
    if (!media || !sourceUrl) return;

    let video = media.querySelector('video');

    if (!video && !reduceMotion.matches) {
      const currentImage = media.querySelector('img');
      video = document.createElement('video');
      video.className = 'vrx-why__video';
      video.dataset.vrxWhyVideoElement = 'true';
      if (posterUrl) video.poster = posterUrl;
      video.src = sourceUrl;
      hardenAutoplay(video);

      if (currentImage) currentImage.replaceWith(video);
      else media.prepend(video);

      video.load();
    }

    if (video) hardenAutoplay(video);
  };

  const replaceReturnImage = (root) => {
    const replacementUrl = getConfig()?.dataset.vrxReturnImage;
    if (!replacementUrl) return;

    const returnCard = [...root.querySelectorAll('.vrx-ritual-card')].find(
      (card) => card.querySelector('h3')?.textContent.trim().toUpperCase() === 'RETURN'
    );
    const image = returnCard?.querySelector('img');
    if (!image || image.dataset.vrxReturnImageReady === 'true') return;

    image.src = replacementUrl;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.alt = 'Back view of a woman with long dark wavy hair during the Vana Ritual';
    image.width = 1024;
    image.height = 1535;
    image.loading = 'lazy';
    image.decoding = 'async';
    image.dataset.vrxReturnImageReady = 'true';
  };

  const removeIngredientEyebrow = (root) => {
    const eyebrow = root.querySelector('.vrx-ingredients .vrx-heading > .vrx-eyebrow');
    if (eyebrow?.textContent.trim().toUpperCase() === '11 BOTANICALS. ONE RITUAL.') eyebrow.remove();
  };

  const init = (scope = document) => {
    const roots = scope.matches?.('[data-vrx]')
      ? [scope]
      : [...(scope.querySelectorAll?.('[data-vrx]') || [])];

    roots.forEach((root) => {
      ensureWhyVideo(root);
      replaceReturnImage(root);
      removeIngredientEyebrow(root);
    });
  };

  const resumeVideos = () => managedVideos.forEach((video) => safePlay(video));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) resumeVideos();
  });
  window.addEventListener('pageshow', resumeVideos);

  // iOS may block autoplay in Low Power Mode. The first normal page interaction retries
  // playback without ever exposing native video controls.
  document.addEventListener('pointerdown', resumeVideos, { passive: true, once: true });
})();
